// extracted by mini-css-extract-plugin
module.exports = {"toggleBtn":"accordeon-module--toggleBtn--R2Uf8","accordeon":"accordeon-module--accordeon---iBva"};